// // import React, { useState } from "react";
// // import { motion } from "framer-motion";

// // const PRODUCTS = [
// //   {
// //     id: "doc-auto",
// //     title: "Custom Documentation Automation",
// //     subtitle: "EMAN & ASYCUDA format solutions",
// //     short:
// //       "Automate customs documentation with scalable, country-specific compliance.",
// //     details:
// //       "This solution enables end-to-end automation of customs documentation processes by leveraging internationally recognized systems such as EMAN and ASYCUDA. Designed for scalability and compliance, it supports the generation and submission of electronic customs documents—such as cargo manifests and import/export declarations—tailored to meet the specific regulatory and formatting requirements of individual countries. By automating these complex processes, the solution significantly reduces manual intervention, minimizes errors, and accelerates customs clearance. The customizable framework ensures seamless adaptation to evolving national regulations, supporting global trade operations with increased efficiency, accuracy, and regulatory compliance.",
// //     bullets: [
// //       "EMAN & ASYCUDA format ready",
// //       "End-to-end automation of customs documentation",
// //       "Supports evolving national regulations",
// //     ],
// //   },
// //   {
// //     id: "ops-mgmt",
// //     title: "Operations Management Software",
// //     subtitle: "Sales, Purchase, Delivery Orders & Invoicing",
// //     short:
// //       "Streamline and digitize day-to-day operations with integrated or stand-alone modules.",
// //     details:
// //       "This solution offers a comprehensive Operations Management Software suite designed to optimize and automate key day-to-day business activities. Available as fully integrated or stand-alone modules, the system covers critical operational areas including sales orders, purchase orders, delivery management, and invoicing. The software provides a centralized platform to manage the full transaction lifecycle—from order initiation to final invoicing—enhancing visibility, traceability, and control across departments. By digitizing and automating routine workflows, it helps organizations reduce manual errors, accelerate processing times, and improve overall operational efficiency.",
// //     bullets: [
// //       "Integrated or modular setup",
// //       "Covers sales, purchase, delivery & invoicing",
// //       "Full transaction lifecycle visibility",
// //     ],
// //   },
// //   {
// //     id: "freight-fwd",
// //     title: "Freight Forwarding Software",
// //     subtitle: "Booking, Consolidation & Billing",
// //     short: "End-to-end freight lifecycle management for air, sea, and land.",
// //     details:
// //       "This Freight Forwarding Software solution is designed to support the full lifecycle of freight management—from initial booking to final billing. It provides freight forwarders with a centralized platform to manage core operational tasks such as shipment booking, cargo consolidation, documentation, tracking, and invoicing across air, sea, and land freight. By automating and integrating these processes, the software enhances visibility, coordination, and efficiency throughout the supply chain. It enables real-time access to shipment data, simplifies complex logistics workflows, and ensures accurate and timely billing.",
// //     bullets: [
// //       "Manage booking, consolidation & billing",
// //       "Supports air, sea & land freight",
// //       "Centralized operational visibility",
// //     ],
// //   },
// //   {
// //     id: "ai-chat",
// //     title: "AI Chatbots & Virtual Assistants",
// //     subtitle: "Intelligent Customer Support",
// //     short:
// //       "Instant shipment status, documentation queries, and self-service support.",
// //     details:
// //       "This Intelligent Customer Support solution leverages AI and automation to provide immediate, accurate responses to customer inquiries related to shipment status, documentation, and general support needs. Designed to enhance service quality and reduce response times, the system offers real-time assistance through digital channels such as chatbots, email, and support portals. By automating routine queries and providing self-service capabilities, the solution significantly reduces the burden on support teams while ensuring a consistent and high-quality customer experience. Advanced integration with shipment and documentation systems allows the platform to deliver up-to-date information instantly, improving transparency and client satisfaction.",
// //     bullets: [
// //       "AI-powered chatbots for instant response",
// //       "Supports shipment & documentation queries",
// //       "Improves transparency & client satisfaction",
// //     ],
// //   },
// // ];

// // const FAQS = [
// //   {
// //     question: "Does your software integrate with ERP systems?",
// //     answer:
// //       "Yes, all our products support API and file-based ERP integrations.",
// //   },
// //   {
// //     question: "Is your Freight Forwarding Software multi-modal?",
// //     answer:
// //       "Yes, it supports air, sea, and land freight in a unified platform.",
// //   },
// //   {
// //     question: "Do you offer AI-based predictive analytics?",
// //     answer:
// //       "Yes, our AI modules optimize operations, forecast demand, and improve decision-making.",
// //   },
// //   {
// //     question: "Are the solutions mobile-friendly?",
// //     answer: "Yes, all solutions are fully responsive across devices.",
// //   },
// // ];

// // export default function ProductsSection() {
// //   const [active, setActive] = useState(null);
// //   const [faqActive, setFaqActive] = useState(null);

// //   return (
// //     <section className="bg-gradient-to-br from-white via-sky-50 to-green-50 py-12 px-4 md:px-8 font-sans">
// //       <div className="max-w-7xl mx-auto">
// //         {/* Header */}
// //         <div className="text-center mb-12">
// //           <h2 className="text-4xl font-extrabold text-green-700">
// //             Products & Services
// //           </h2>
// //           <p className="text-slate-600 mt-3 max-w-2xl mx-auto">
// //             Comprehensive digital solutions for logistics, shipping, freight
// //             forwarding, and customer support.
// //           </p>
// //         </div>

// //         {/* Product Grid */}
// //         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
// //           {PRODUCTS.map((p) => (
// //             <motion.article
// //               key={p.id}
// //               layout
// //               initial={{ opacity: 0, y: 8 }}
// //               animate={{ opacity: 1, y: 0 }}
// //               whileHover={{ translateY: -6 }}
// //               className="bg-white rounded-2xl shadow-md hover:shadow-xl p-6 flex flex-col border border-green-100"
// //             >
// //               <h3 className="text-lg font-bold text-green-700">{p.title}</h3>
// //               <p className="text-sm text-sky-600 mt-1">{p.subtitle}</p>
// //               <p className="text-sm text-slate-600 mt-4 flex-1">{p.short}</p>
// //               <button
// //                 onClick={() => setActive(p.id)}
// //                 className="mt-4 px-4 py-2 rounded-lg bg-green-600 text-white text-sm font-medium shadow hover:bg-green-700 transition"
// //               >
// //                 Learn More
// //               </button>
// //             </motion.article>
// //           ))}
// //         </div>

// //         {/* FAQ Section */}
// //         <div className="mt-20">
// //           <h2 className="text-3xl font-bold text-green-700 mb-6 text-center">
// //             FAQs
// //           </h2>
// //           <div className="flex flex-col gap-4 max-w-3xl mx-auto">
// //             {FAQS.map((faq, i) => (
// //               <div
// //                 key={i}
// //                 className="border rounded-lg overflow-hidden shadow-sm"
// //               >
// //                 <button
// //                   onClick={() => setFaqActive(faqActive === i ? null : i)}
// //                   className="w-full px-4 py-3 text-left bg-green-50 flex justify-between items-center text-green-700 font-medium"
// //                 >
// //                   <span>{faq.question}</span>
// //                   <span>{faqActive === i ? "−" : "+"}</span>
// //                 </button>
// //                 {faqActive === i && (
// //                   <div className="px-4 py-3 bg-white text-slate-600 text-sm">
// //                     {faq.answer}
// //                   </div>
// //                 )}
// //               </div>
// //             ))}
// //           </div>
// //         </div>

// //         {/* CTA Section */}
// //         <div className="mt-20 bg-gradient-to-r from-green-600 to-sky-600 rounded-2xl shadow-lg p-10 text-center text-white">
// //           <h3 className="text-2xl md:text-3xl font-bold">
// //             Ready to transform your logistics?
// //           </h3>
// //           <p className="mt-3 text-lg opacity-90">
// //             Connect with our team for demos, pilots, and tailored solutions.
// //           </p>
// //           <div className="mt-6 flex gap-4 justify-center flex-wrap">
// //             <button className="px-6 py-3 rounded-lg bg-white text-green-700 font-semibold shadow hover:bg-green-50">
// //               Get in Touch
// //             </button>
// //             <button className="px-6 py-3 rounded-lg border border-white font-semibold hover:bg-white hover:text-green-700 transition">
// //               Request Demo
// //             </button>
// //           </div>
// //         </div>

// //         {/* Modal with details */}
// //         {active && (
// //           <div className="fixed inset-0 z-40 flex items-center justify-center">
// //             <div
// //               onClick={() => setActive(null)}
// //               className="absolute inset-0 bg-black/40 backdrop-blur-sm"
// //             />
// //             <motion.div
// //               initial={{ scale: 0.95, opacity: 0 }}
// //               animate={{ scale: 1, opacity: 1 }}
// //               className="relative bg-white rounded-2xl shadow-2xl max-w-2xl w-full m-6 p-6 z-50"
// //             >
// //               <button
// //                 onClick={() => setActive(null)}
// //                 className="absolute top-4 right-4 text-slate-400 hover:text-slate-600"
// //               >
// //                 ✕
// //               </button>
// //               {(() => {
// //                 const prod = PRODUCTS.find((x) => x.id === active);
// //                 if (!prod) return null;
// //                 return (
// //                   <div>
// //                     <h3 className="text-2xl font-bold text-green-700">
// //                       {prod.title}
// //                     </h3>
// //                     <p className="text-sm text-sky-600 mt-1">{prod.subtitle}</p>
// //                     <p className="mt-4 text-slate-600 text-sm">
// //                       {prod.details}
// //                     </p>
// //                     <h4 className="mt-6 font-semibold text-slate-800">
// //                       Highlights
// //                     </h4>
// //                     <ul className="list-disc ml-5 mt-2 text-slate-600 text-sm">
// //                       {prod.bullets.map((b, i) => (
// //                         <li key={i}>{b}</li>
// //                       ))}
// //                     </ul>
// //                     <div className="mt-6 flex gap-3 flex-wrap">
// //                       <button className="px-4 py-2 rounded-lg bg-green-600 text-white shadow hover:bg-green-700">
// //                         Contact Sales
// //                       </button>
// //                       <button className="px-4 py-2 rounded-lg border border-green-600 text-green-700 hover:bg-green-50">
// //                         Request Demo
// //                       </button>
// //                     </div>
// //                   </div>
// //                 );
// //               })()}
// //             </motion.div>
// //           </div>
// //         )}
// //       </div>
// //     </section>
// //   );
// // }

// // import React, { useState } from "react";
// // import { motion } from "framer-motion";
// // import { Helmet } from "react-helmet";
// // import { useNavigate } from "react-router-dom";

// // const PRODUCTS = [
// //   {
// //     id: "doc-auto",
// //     title: "Custom Documentation Automation",
// //     subtitle: "EMAN & ASYCUDA format solutions",
// //     short:
// //       "Automate customs documentation with scalable, country-specific compliance.",
// //     details:
// //       "This solution enables end-to-end automation of customs documentation processes by leveraging internationally recognized systems such as EMAN and ASYCUDA. Designed for scalability and compliance, it supports the generation and submission of electronic customs documents—such as cargo manifests and import/export declarations—tailored to meet the specific regulatory and formatting requirements of individual countries. By automating these complex processes, the solution significantly reduces manual intervention, minimizes errors, and accelerates customs clearance. The customizable framework ensures seamless adaptation to evolving national regulations, supporting global trade operations with increased efficiency, accuracy, and regulatory compliance.",
// //     bullets: [
// //       "EMAN & ASYCUDA format ready",
// //       "End-to-end automation of customs documentation",
// //       "Supports evolving national regulations",
// //     ],
// //   },
// //   {
// //     id: "ops-mgmt",
// //     title: "Operations Management Software",
// //     subtitle: "Sales, Purchase, Delivery Orders & Invoicing",
// //     short:
// //       "Streamline and digitize day-to-day operations with integrated or stand-alone modules.",
// //     details:
// //       "This solution offers a comprehensive Operations Management Software suite designed to optimize and automate key day-to-day business activities. Available as fully integrated or stand-alone modules, the system covers critical operational areas including sales orders, purchase orders, delivery management, and invoicing. The software provides a centralized platform to manage the full transaction lifecycle—from order initiation to final invoicing—enhancing visibility, traceability, and control across departments. By digitizing and automating routine workflows, it helps organizations reduce manual errors, accelerate processing times, and improve overall operational efficiency.",
// //     bullets: [
// //       "Integrated or modular setup",
// //       "Covers sales, purchase, delivery & invoicing",
// //       "Full transaction lifecycle visibility",
// //     ],
// //   },
// //   {
// //     id: "freight-fwd",
// //     title: "Freight Forwarding Software",
// //     subtitle: "Booking, Consolidation & Billing",
// //     short: "End-to-end freight lifecycle management for air, sea, and land.",
// //     details:
// //       "This Freight Forwarding Software solution is designed to support the full lifecycle of freight management—from initial booking to final billing. It provides freight forwarders with a centralized platform to manage core operational tasks such as shipment booking, cargo consolidation, documentation, tracking, and invoicing across air, sea, and land freight. By automating and integrating these processes, the software enhances visibility, coordination, and efficiency throughout the supply chain. It enables real-time access to shipment data, simplifies complex logistics workflows, and ensures accurate and timely billing.",
// //     bullets: [
// //       "Manage booking, consolidation & billing",
// //       "Supports air, sea & land freight",
// //       "Centralized operational visibility",
// //     ],
// //   },
// //   {
// //     id: "ai-chat",
// //     title: "AI Chatbots & Virtual Assistants",
// //     subtitle: "Intelligent Customer Support",
// //     short:
// //       "Instant shipment status, documentation queries, and self-service support.",
// //     details:
// //       "This Intelligent Customer Support solution leverages AI and automation to provide immediate, accurate responses to customer inquiries related to shipment status, documentation, and general support needs. Designed to enhance service quality and reduce response times, the system offers real-time assistance through digital channels such as chatbots, email, and support portals. By automating routine queries and providing self-service capabilities, the solution significantly reduces the burden on support teams while ensuring a consistent and high-quality customer experience. Advanced integration with shipment and documentation systems allows the platform to deliver up-to-date information instantly, improving transparency and client satisfaction.",
// //     bullets: [
// //       "AI-powered chatbots for instant response",
// //       "Supports shipment & documentation queries",
// //       "Improves transparency & client satisfaction",
// //     ],
// //   },
// // ];

// // const FAQS = [
// //   {
// //     question: "Does your software integrate with ERP systems?",
// //     answer:
// //       "Yes, all our products support API and file-based ERP integrations.",
// //   },
// //   {
// //     question: "Is your Freight Forwarding Software multi-modal?",
// //     answer:
// //       "Yes, it supports air, sea, and land freight in a unified platform.",
// //   },
// //   {
// //     question: "Do you offer AI-based predictive analytics?",
// //     answer:
// //       "Yes, our AI modules optimize operations, forecast demand, and improve decision-making.",
// //   },
// //   {
// //     question: "Are the solutions mobile-friendly?",
// //     answer: "Yes, all solutions are fully responsive across devices.",
// //   },
// // ];

// // export default function ProductsSection() {
// //   const [active, setActive] = useState(null);
// //   const [faqActive, setFaqActive] = useState(null);
// //   const navigate = useNavigate();

// //   return (
// //     <section className="bg-gradient-to-br from-white via-sky-50 to-green-50 py-12 px-4 md:px-8 font-sans">
// //       {/* SEO Meta Tags */}
// //       <Helmet>
// //         <title>Products & Services | Logistics & Freight Solutions</title>
// //         <meta
// //           name="description"
// //           content="Explore our products and services for logistics, shipping, freight forwarding, operations management, and AI customer support."
// //         />
// //         <meta
// //           name="keywords"
// //           content="logistics software, freight forwarding, documentation automation, operations management, AI chatbots"
// //         />
// //         <meta name="author" content="Your Company Name" />
// //       </Helmet>

// //       <div className="max-w-7xl mx-auto">
// //         {/* Header */}
// //         <div className="text-center mb-12">
// //           <h2 className="text-4xl font-extrabold text-green-700">
// //             Products & Services
// //           </h2>
// //           <p className="text-slate-600 mt-3 max-w-2xl mx-auto">
// //             Comprehensive digital solutions for logistics, shipping, freight
// //             forwarding, and customer support.
// //           </p>
// //         </div>

// //         {/* Product Grid */}
// //         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
// //           {PRODUCTS.map((p) => (
// //             <motion.article
// //               key={p.id}
// //               layout
// //               initial={{ opacity: 0, y: 8 }}
// //               animate={{ opacity: 1, y: 0 }}
// //               whileHover={{ translateY: -6 }}
// //               className="bg-white rounded-2xl shadow-md hover:shadow-xl p-6 flex flex-col border border-green-100"
// //             >
// //               <h3 className="text-lg font-bold text-green-700">{p.title}</h3>
// //               <p className="text-sm text-sky-600 mt-1">{p.subtitle}</p>
// //               <p className="text-sm text-slate-600 mt-4 flex-1">{p.short}</p>
// //               <button
// //                 onClick={() => setActive(p.id)}
// //                 className="mt-4 px-4 py-2 rounded-lg bg-green-600 text-white text-sm font-medium shadow hover:bg-green-700 transition"
// //               >
// //                 Learn More
// //               </button>
// //             </motion.article>
// //           ))}
// //         </div>

// //         {/* FAQ Section */}
// //         <div className="mt-20">
// //           <h2 className="text-3xl font-bold text-green-700 mb-6 text-center">
// //             FAQs
// //           </h2>
// //           <div className="flex flex-col gap-4 max-w-3xl mx-auto">
// //             {FAQS.map((faq, i) => (
// //               <div
// //                 key={i}
// //                 className="border rounded-lg overflow-hidden shadow-sm"
// //               >
// //                 <button
// //                   onClick={() => setFaqActive(faqActive === i ? null : i)}
// //                   className="w-full px-4 py-3 text-left bg-green-50 flex justify-between items-center text-green-700 font-medium"
// //                 >
// //                   <span>{faq.question}</span>
// //                   <span>{faqActive === i ? "−" : "+"}</span>
// //                 </button>
// //                 {faqActive === i && (
// //                   <div className="px-4 py-3 bg-white text-slate-600 text-sm">
// //                     {faq.answer}
// //                   </div>
// //                 )}
// //               </div>
// //             ))}
// //           </div>
// //         </div>

// //         {/* CTA Section */}
// //         <div className="mt-20 bg-gradient-to-r from-green-600 to-sky-600 rounded-2xl shadow-lg p-10 text-center text-white">
// //           <h3 className="text-2xl md:text-3xl font-bold">
// //             Ready to transform your logistics?
// //           </h3>
// //           <p className="mt-3 text-lg opacity-90">
// //             Connect with our team for demos, pilots, and tailored solutions.
// //           </p>
// //           <div className="mt-6 flex gap-4 justify-center flex-wrap">
// //             <button
// //               onClick={() => navigate("/contact")}
// //               className="px-6 py-3 rounded-lg bg-white text-green-700 font-semibold shadow hover:bg-green-50"
// //             >
// //               Get in Touch
// //             </button>
// //           </div>
// //         </div>

// //         {/* Modal with details */}
// //         {active && (
// //           <div className="fixed inset-0 z-40 flex items-center justify-center">
// //             <div
// //               onClick={() => setActive(null)}
// //               className="absolute inset-0 bg-black/40 backdrop-blur-sm"
// //             />
// //             <motion.div
// //               initial={{ scale: 0.95, opacity: 0 }}
// //               animate={{ scale: 1, opacity: 1 }}
// //               className="relative bg-white rounded-2xl shadow-2xl max-w-2xl w-full m-6 p-6 z-50"
// //             >
// //               <button
// //                 onClick={() => setActive(null)}
// //                 className="absolute top-4 right-4 text-slate-400 hover:text-slate-600"
// //               >
// //                 ✕
// //               </button>
// //               {(() => {
// //                 const prod = PRODUCTS.find((x) => x.id === active);
// //                 if (!prod) return null;
// //                 return (
// //                   <div>
// //                     <h3 className="text-2xl font-bold text-green-700">
// //                       {prod.title}
// //                     </h3>
// //                     <p className="text-sm text-sky-600 mt-1">{prod.subtitle}</p>
// //                     <p className="mt-4 text-slate-600 text-sm">
// //                       {prod.details}
// //                     </p>
// //                     <h4 className="mt-6 font-semibold text-slate-800">
// //                       Highlights
// //                     </h4>
// //                     <ul className="list-disc ml-5 mt-2 text-slate-600 text-sm">
// //                       {prod.bullets.map((b, i) => (
// //                         <li key={i}>{b}</li>
// //                       ))}
// //                     </ul>
// //                     <div className="mt-6 flex gap-3 flex-wrap">
// //                       <button
// //                         onClick={() => navigate("/contact")}
// //                         className="px-4 py-2 rounded-lg bg-green-600 text-white shadow hover:bg-green-700"
// //                       >
// //                         Contact Sales
// //                       </button>
// //                     </div>
// //                   </div>
// //                 );
// //               })()}
// //             </motion.div>
// //           </div>
// //         )}
// //       </div>
// //     </section>
// //   );
// // }

// import React, { useState } from "react";
// import { motion } from "framer-motion";
// import { Helmet } from "react-helmet";
// import { useNavigate } from "react-router-dom";

// const PRODUCTS = [
//   {
//     id: "doc-auto",
//     title: "Custom Documentation Automation",
//     subtitle: "EMAN & ASYCUDA format solutions",
//     short:
//       "Automate customs documentation with scalable, country-specific compliance.",
//     details:
//       "This solution enables end-to-end automation of customs documentation processes by leveraging internationally recognized systems such as EMAN and ASYCUDA. Designed for scalability and compliance, it supports the generation and submission of electronic customs documents—such as cargo manifests and import/export declarations—tailored to meet the specific regulatory and formatting requirements of individual countries. By automating these complex processes, the solution significantly reduces manual intervention, minimizes errors, and accelerates customs clearance. The customizable framework ensures seamless adaptation to evolving national regulations, supporting global trade operations with increased efficiency, accuracy, and regulatory compliance.",
//     bullets: [
//       "EMAN & ASYCUDA format ready",
//       "End-to-end automation of customs documentation",
//       "Supports evolving national regulations",
//     ],
//   },
//   {
//     id: "ops-mgmt",
//     title: "Operations Management Software",
//     subtitle: "Sales, Purchase, Delivery Orders & Invoicing",
//     short:
//       "Streamline and digitize day-to-day operations with integrated or stand-alone modules.",
//     details:
//       "This solution offers a comprehensive Operations Management Software suite designed to optimize and automate key day-to-day business activities. Available as fully integrated or stand-alone modules, the system covers critical operational areas including sales orders, purchase orders, delivery management, and invoicing. The software provides a centralized platform to manage the full transaction lifecycle—from order initiation to final invoicing—enhancing visibility, traceability, and control across departments. By digitizing and automating routine workflows, it helps organizations reduce manual errors, accelerate processing times, and improve overall operational efficiency.",
//     bullets: [
//       "Integrated or modular setup",
//       "Covers sales, purchase, delivery & invoicing",
//       "Full transaction lifecycle visibility",
//     ],
//   },
//   {
//     id: "freight-fwd",
//     title: "Freight Forwarding Software",
//     subtitle: "Booking, Consolidation & Billing",
//     short: "End-to-end freight lifecycle management for air, sea, and land.",
//     details:
//       "This Freight Forwarding Software solution is designed to support the full lifecycle of freight management—from initial booking to final billing. It provides freight forwarders with a centralized platform to manage core operational tasks such as shipment booking, cargo consolidation, documentation, tracking, and invoicing across air, sea, and land freight. By automating and integrating these processes, the software enhances visibility, coordination, and efficiency throughout the supply chain. It enables real-time access to shipment data, simplifies complex logistics workflows, and ensures accurate and timely billing.",
//     bullets: [
//       "Manage booking, consolidation & billing",
//       "Supports air, sea & land freight",
//       "Centralized operational visibility",
//     ],
//   },
//   {
//     id: "ai-chat",
//     title: "AI Chatbots & Virtual Assistants",
//     subtitle: "Intelligent Customer Support",
//     short:
//       "Instant shipment status, documentation queries, and self-service support.",
//     details:
//       "This Intelligent Customer Support solution leverages AI and automation to provide immediate, accurate responses to customer inquiries related to shipment status, documentation, and general support needs. Designed to enhance service quality and reduce response times, the system offers real-time assistance through digital channels such as chatbots, email, and support portals. By automating routine queries and providing self-service capabilities, the solution significantly reduces the burden on support teams while ensuring a consistent and high-quality customer experience. Advanced integration with shipment and documentation systems allows the platform to deliver up-to-date information instantly, improving transparency and client satisfaction.",
//     bullets: [
//       "AI-powered chatbots for instant response",
//       "Supports shipment & documentation queries",
//       "Improves transparency & client satisfaction",
//     ],
//   },
// ];

// const FAQS = [
//   {
//     question: "Does your software integrate with ERP systems?",
//     answer:
//       "Yes, all our products support API and file-based ERP integrations.",
//   },
//   {
//     question: "Is your Freight Forwarding Software multi-modal?",
//     answer:
//       "Yes, it supports air, sea, and land freight in a unified platform.",
//   },
//   {
//     question: "Do you offer AI-based predictive analytics?",
//     answer:
//       "Yes, our AI modules optimize operations, forecast demand, and improve decision-making.",
//   },
//   {
//     question: "Are the solutions mobile-friendly?",
//     answer: "Yes, all solutions are fully responsive across devices.",
//   },
// ];

// export default function ProductsSection() {
//   const [active, setActive] = useState(null);
//   const [faqActive, setFaqActive] = useState(null);
//   const navigate = useNavigate();

//   return (
//     <section className="bg-gradient-to-br from-white via-sky-50 to-green-50 py-12 px-4 md:px-8 font-sans">
//       {/* SEO Meta Tags */}
//       <Helmet>
//         <title>Products & Services | Logistics & Freight Solutions</title>
//         <meta
//           name="description"
//           content="Explore our products and services for logistics, shipping, freight forwarding, operations management, and AI customer support."
//         />
//         <meta
//           name="keywords"
//           content="logistics software, freight forwarding, documentation automation, operations management, AI chatbots"
//         />
//         <meta name="author" content="Your Company Name" />
//       </Helmet>

//       <div className="max-w-7xl mx-auto">
//         {/* Header */}
//         <div className="text-center mb-12">
//           <h2 className="text-3xl sm:text-4xl font-extrabold text-green-700">
//             Products & Services
//           </h2>
//           <p className="text-slate-600 mt-3 max-w-2xl mx-auto text-sm sm:text-base">
//             Comprehensive digital solutions for logistics, shipping, freight
//             forwarding, and customer support.
//           </p>
//         </div>

//         {/* Product Grid */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
//           {PRODUCTS.map((p) => (
//             <motion.article
//               key={p.id}
//               layout
//               initial={{ opacity: 0, y: 8 }}
//               animate={{ opacity: 1, y: 0 }}
//               whileHover={{ translateY: -6 }}
//               className="bg-white rounded-2xl shadow-md hover:shadow-xl p-4 sm:p-6 flex flex-col h-full border border-green-100"
//             >
//               <h3 className="text-base sm:text-lg font-bold text-green-700">
//                 {p.title}
//               </h3>
//               <p className="text-sm text-sky-600 mt-1">{p.subtitle}</p>
//               <p className="text-sm text-slate-600 mt-4 flex-1">{p.short}</p>
//               <button
//                 onClick={() => setActive(p.id)}
//                 className="mt-4 px-4 py-2 rounded-lg bg-green-600 text-white text-sm font-medium shadow hover:bg-green-700 transition"
//               >
//                 Learn More
//               </button>
//             </motion.article>
//           ))}
//         </div>

//         {/* FAQ Section */}
//         <div className="mt-20">
//           <h2 className="text-2xl sm:text-3xl font-bold text-green-700 mb-6 text-center">
//             FAQs
//           </h2>
//           <div className="flex flex-col gap-4 max-w-3xl mx-auto">
//             {FAQS.map((faq, i) => (
//               <div
//                 key={i}
//                 className="border rounded-lg overflow-hidden shadow-sm"
//               >
//                 <button
//                   onClick={() => setFaqActive(faqActive === i ? null : i)}
//                   className="w-full px-4 py-3 text-left bg-green-50 flex justify-between items-center text-green-700 font-medium text-sm sm:text-base"
//                 >
//                   <span>{faq.question}</span>
//                   <span>{faqActive === i ? "−" : "+"}</span>
//                 </button>
//                 {faqActive === i && (
//                   <div className="px-4 py-3 bg-white text-slate-600 text-sm sm:text-base">
//                     {faq.answer}
//                   </div>
//                 )}
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* CTA Section */}
//         <div className="mt-20 bg-gradient-to-r from-green-600 to-sky-600 rounded-2xl shadow-lg px-6 py-8 sm:p-10 text-center text-white">
//           <h3 className="text-xl sm:text-2xl md:text-3xl font-bold">
//             Ready to transform your logistics?
//           </h3>
//           <p className="mt-3 text-sm sm:text-lg opacity-90 max-w-xl mx-auto">
//             Connect with our team for demos, pilots, and tailored solutions.
//           </p>
//           <div className="mt-6 flex gap-4 justify-center flex-wrap">
//             <button
//               onClick={() => navigate("/contact")}
//               className="px-5 sm:px-6 py-3 rounded-lg bg-white text-green-700 font-semibold shadow hover:bg-green-50 text-sm sm:text-base"
//             >
//               Get in Touch
//             </button>
//           </div>
//         </div>

//         {/* Modal with details */}
//         {active && (
//           <div className="fixed inset-0 z-40 flex items-center justify-center px-4 sm:px-6">
//             <div
//               onClick={() => setActive(null)}
//               className="absolute inset-0 bg-black/40 backdrop-blur-sm"
//             />
//             <motion.div
//               initial={{ scale: 0.95, opacity: 0 }}
//               animate={{ scale: 1, opacity: 1 }}
//               className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md sm:max-w-2xl max-h-[90vh] overflow-y-auto p-6 z-50"
//             >
//               <button
//                 onClick={() => setActive(null)}
//                 className="absolute top-4 right-4 text-slate-400 hover:text-slate-600"
//               >
//                 ✕
//               </button>
//               {(() => {
//                 const prod = PRODUCTS.find((x) => x.id === active);
//                 if (!prod) return null;
//                 return (
//                   <div>
//                     <h3 className="text-xl sm:text-2xl font-bold text-green-700">
//                       {prod.title}
//                     </h3>
//                     <p className="text-sm text-sky-600 mt-1">{prod.subtitle}</p>
//                     <p className="mt-4 text-slate-600 text-sm sm:text-base">
//                       {prod.details}
//                     </p>
//                     <h4 className="mt-6 font-semibold text-slate-800">
//                       Highlights
//                     </h4>
//                     <ul className="list-disc ml-5 mt-2 text-slate-600 text-sm sm:text-base">
//                       {prod.bullets.map((b, i) => (
//                         <li key={i}>{b}</li>
//                       ))}
//                     </ul>
//                     <div className="mt-6 flex gap-3 flex-wrap">
//                       <button
//                         onClick={() => navigate("/contact")}
//                         className="px-4 py-2 rounded-lg bg-green-600 text-white shadow hover:bg-green-700 text-sm sm:text-base"
//                       >
//                         Contact Sales
//                       </button>
//                     </div>
//                   </div>
//                 );
//               })()}
//             </motion.div>
//           </div>
//         )}
//       </div>
//     </section>
//   );
// }

// import React, { useState } from "react";
// import { motion } from "framer-motion";
// import { Helmet } from "react-helmet";
// import { useNavigate } from "react-router-dom";

// const PRODUCTS = [
//   {
//     id: "doc-auto",
//     title: "Custom Documentation Automation",
//     subtitle: "EMAN & ASYCUDA format solutions",
//     short:
//       "Automate customs documentation with scalable, country-specific compliance.",
//     details:
//       "This solution enables end-to-end automation of customs documentation processes by leveraging internationally recognized systems such as EMAN and ASYCUDA. Designed for scalability and compliance, it supports the generation and submission of electronic customs documents—such as cargo manifests and import/export declarations—tailored to meet the specific regulatory and formatting requirements of individual countries. By automating these complex processes, the solution significantly reduces manual intervention, minimizes errors, and accelerates customs clearance. The customizable framework ensures seamless adaptation to evolving national regulations, supporting global trade operations with increased efficiency, accuracy, and regulatory compliance.",
//     bullets: [
//       "EMAN & ASYCUDA format ready",
//       "End-to-end automation of customs documentation",
//       "Supports evolving national regulations",
//     ],
//   },
//   {
//     id: "ops-mgmt",
//     title: "Operations Management Software",
//     subtitle: "Sales, Purchase, Delivery Orders & Invoicing",
//     short:
//       "Streamline and digitize day-to-day operations with integrated or stand-alone modules.",
//     details:
//       "This solution offers a comprehensive Operations Management Software suite designed to optimize and automate key day-to-day business activities. Available as fully integrated or stand-alone modules, the system covers critical operational areas including sales orders, purchase orders, delivery management, and invoicing. The software provides a centralized platform to manage the full transaction lifecycle—from order initiation to final invoicing—enhancing visibility, traceability, and control across departments. By digitizing and automating routine workflows, it helps organizations reduce manual errors, accelerate processing times, and improve overall operational efficiency.",
//     bullets: [
//       "Integrated or modular setup",
//       "Covers sales, purchase, delivery & invoicing",
//       "Full transaction lifecycle visibility",
//     ],
//   },
//   {
//     id: "freight-fwd",
//     title: "Freight Forwarding Software",
//     subtitle: "Booking, Consolidation & Billing",
//     short: "End-to-end freight lifecycle management for air, sea, and land.",
//     details:
//       "This Freight Forwarding Software solution is designed to support the full lifecycle of freight management—from initial booking to final billing. It provides freight forwarders with a centralized platform to manage core operational tasks such as shipment booking, cargo consolidation, documentation, tracking, and invoicing across air, sea, and land freight. By automating and integrating these processes, the software enhances visibility, coordination, and efficiency throughout the supply chain. It enables real-time access to shipment data, simplifies complex logistics workflows, and ensures accurate and timely billing.",
//     bullets: [
//       "Manage booking, consolidation & billing",
//       "Supports air, sea & land freight",
//       "Centralized operational visibility",
//     ],
//   },
//   {
//     id: "ai-chat",
//     title: "AI Chatbots & Virtual Assistants",
//     subtitle: "Intelligent Customer Support",
//     short:
//       "Instant shipment status, documentation queries, and self-service support.",
//     details:
//       "This Intelligent Customer Support solution leverages AI and automation to provide immediate, accurate responses to customer inquiries related to shipment status, documentation, and general support needs. Designed to enhance service quality and reduce response times, the system offers real-time assistance through digital channels such as chatbots, email, and support portals. By automating routine queries and providing self-service capabilities, the solution significantly reduces the burden on support teams while ensuring a consistent and high-quality customer experience. Advanced integration with shipment and documentation systems allows the platform to deliver up-to-date information instantly, improving transparency and client satisfaction.",
//     bullets: [
//       "AI-powered chatbots for instant response",
//       "Supports shipment & documentation queries",
//       "Improves transparency & client satisfaction",
//     ],
//   },
// ];

// const FAQS = [
//   {
//     question: "Does your software integrate with ERP systems?",
//     answer:
//       "Yes, all our products support API and file-based ERP integrations.",
//   },
//   {
//     question: "Is your Freight Forwarding Software multi-modal?",
//     answer:
//       "Yes, it supports air, sea, and land freight in a unified platform.",
//   },
//   {
//     question: "Do you offer AI-based predictive analytics?",
//     answer:
//       "Yes, our AI modules optimize operations, forecast demand, and improve decision-making.",
//   },
//   {
//     question: "Are the solutions mobile-friendly?",
//     answer: "Yes, all solutions are fully responsive across devices.",
//   },
// ];

// export default function ProductsSection() {
//   const [active, setActive] = useState(null);
//   const [faqActive, setFaqActive] = useState(null);
//   const navigate = useNavigate();

//   return (
//     <section className="bg-gradient-to-br from-white via-sky-50 to-green-50 py-12 px-4 md:px-8 font-sans">
//       {/* SEO Meta Tags */}
//       <Helmet>
//         <title>Products & Services | Logistics & Freight Solutions</title>
//         <meta
//           name="description"
//           content="Explore our products and services for logistics, shipping, freight forwarding, operations management, and AI customer support."
//         />
//         <meta
//           name="keywords"
//           content="logistics software, freight forwarding, documentation automation, operations management, AI chatbots"
//         />
//         <meta name="author" content="Your Company Name" />
//       </Helmet>

//       <div className="max-w-7xl mx-auto">
//         {/* Header */}
//         <div className="text-center mb-12">
//           <h2 className="text-3xl sm:text-4xl font-extrabold text-green-700">
//             Products & Services
//           </h2>
//           <p className="text-slate-600 mt-3 max-w-2xl mx-auto text-sm sm:text-base">
//             Comprehensive digital solutions for logistics, shipping, freight
//             forwarding, and customer support.
//           </p>
//         </div>

//         {/* Product Grid */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
//           {PRODUCTS.map((p) => (
//             <motion.article
//               key={p.id}
//               layout
//               initial={{ opacity: 0, y: 8 }}
//               animate={{ opacity: 1, y: 0 }}
//               whileHover={{ translateY: -6 }}
//               className="bg-white rounded-2xl shadow-md hover:shadow-xl p-4 sm:p-6 flex flex-col h-full border border-green-100"
//             >
//               <h3 className="text-base sm:text-lg font-bold text-green-700">
//                 {p.title}
//               </h3>
//               <p className="text-sm text-sky-600 mt-1">{p.subtitle}</p>
//               <p className="text-sm text-slate-600 mt-4 flex-1">{p.short}</p>
//               <button
//                 onClick={() => setActive(p.id)}
//                 className="mt-4 px-4 py-2 rounded-lg bg-green-600 text-white text-sm font-medium shadow hover:bg-green-700 transition"
//               >
//                 Learn More
//               </button>
//             </motion.article>
//           ))}
//         </div>

//         {/* FAQ Section */}
//         <div className="mt-20">
//           <h2 className="text-2xl sm:text-3xl font-bold text-green-700 mb-6 text-center">
//             FAQs
//           </h2>
//           <div className="flex flex-col gap-4 max-w-3xl mx-auto">
//             {FAQS.map((faq, i) => (
//               <div
//                 key={i}
//                 className="border rounded-lg overflow-hidden shadow-sm"
//               >
//                 <button
//                   onClick={() => setFaqActive(faqActive === i ? null : i)}
//                   className="w-full px-4 py-3 text-left bg-green-50 flex justify-between items-center text-green-700 font-medium text-sm sm:text-base"
//                 >
//                   <span>{faq.question}</span>
//                   <span>{faqActive === i ? "−" : "+"}</span>
//                 </button>
//                 {faqActive === i && (
//                   <div className="px-4 py-3 bg-white text-slate-600 text-sm sm:text-base">
//                     {faq.answer}
//                   </div>
//                 )}
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* CTA Section */}
//         <div className="mt-20 bg-gradient-to-r from-green-600 to-sky-600 rounded-2xl shadow-lg px-6 py-8 sm:p-10 text-center text-white">
//           <h3 className="text-xl sm:text-2xl md:text-3xl font-bold">
//             Ready to transform your logistics?
//           </h3>
//           <p className="mt-3 text-sm sm:text-lg opacity-90 max-w-xl mx-auto">
//             Connect with our team for demos, pilots, and tailored solutions.
//           </p>
//           <div className="mt-6 flex gap-4 justify-center flex-wrap">
//             <button
//               onClick={() => navigate("/contact")}
//               className="px-5 sm:px-6 py-3 rounded-lg bg-white text-green-700 font-semibold shadow hover:bg-green-50 text-sm sm:text-base"
//             >
//               Get in Touch
//             </button>
//           </div>
//         </div>

//         {/* Modal with details */}
//         {active && (
//           <div className="fixed inset-0 z-[9999] flex items-center justify-center px-2 sm:px-6">
//             {/* Overlay */}
//             <div
//               onClick={() => setActive(null)}
//               className="absolute inset-0 bg-black/50 backdrop-blur-sm"
//             />
//             {/* Popup */}
//             <motion.div
//               initial={{ scale: 0.95, opacity: 0 }}
//               animate={{ scale: 1, opacity: 1 }}
//               className="
//                 relative bg-white rounded-2xl shadow-2xl
//                 w-full max-w-md sm:max-w-2xl
//                 max-h-[90vh] overflow-y-auto
//                 p-5 sm:p-6 z-[10000]
//               "
//             >
//               {/* Close button */}
//               <button
//                 onClick={() => setActive(null)}
//                 className="absolute top-4 right-4 text-slate-400 hover:text-slate-600 text-xl"
//               >
//                 ✕
//               </button>

//               {/* Content */}
//               {(() => {
//                 const prod = PRODUCTS.find((x) => x.id === active);
//                 if (!prod) return null;
//                 return (
//                   <div>
//                     <h3 className="text-lg sm:text-2xl font-bold text-green-700">
//                       {prod.title}
//                     </h3>
//                     <p className="text-sm text-sky-600 mt-1">{prod.subtitle}</p>
//                     <p className="mt-4 text-slate-600 text-sm sm:text-base">
//                       {prod.details}
//                     </p>
//                     <h4 className="mt-6 font-semibold text-slate-800">
//                       Highlights
//                     </h4>
//                     <ul className="list-disc ml-5 mt-2 text-slate-600 text-sm sm:text-base">
//                       {prod.bullets.map((b, i) => (
//                         <li key={i}>{b}</li>
//                       ))}
//                     </ul>
//                     <div className="mt-6 flex gap-3 flex-wrap">
//                       <button
//                         onClick={() => navigate("/contact")}
//                         className="px-4 py-2 rounded-lg bg-green-600 text-white shadow hover:bg-green-700 text-sm sm:text-base"
//                       >
//                         Contact Sales
//                       </button>
//                     </div>
//                   </div>
//                 );
//               })()}
//             </motion.div>
//           </div>
//         )}
//       </div>
//     </section>
//   );
// }

import React, { useState } from "react";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async"; // ✅ SEO
import { useNavigate } from "react-router-dom";

const PRODUCTS = [
  {
    title: "Logistics Software",
    description:
      "AI-powered platform that streamlines operations for shipping and logistics companies.",
    details: [
      "Inventory & warehouse management",
      "Route optimization",
      "Real-time shipment tracking",
    ],
  },
  {
    title: "Freight Forwarding",
    description:
      "Simplify freight forwarding processes with digital documentation and automated workflows.",
    details: [
      "Customs clearance",
      "Multi-modal tracking",
      "Quotation automation",
    ],
  },
  {
    title: "Documentation Automation",
    description:
      "Automate compliance, customs, and shipping documentation with AI-driven accuracy.",
    details: [
      "Error-free customs forms",
      "Document digitization",
      "Secure storage",
    ],
  },
  {
    title: "Operations Management",
    description:
      "End-to-end visibility and control for shipping and logistics operations.",
    details: [
      "Fleet management",
      "Staff productivity analytics",
      "Process automation",
    ],
  },
  {
    title: "Customer Support",
    description:
      "AI-driven chatbots and tools for seamless customer engagement and support.",
    details: [
      "24/7 AI chatbot",
      "Customer analytics dashboard",
      "Multi-channel support",
    ],
  },
];

const FAQS = [
  {
    q: "How does AI improve logistics?",
    a: "AI helps optimize routes, reduce operational costs, and improve shipment accuracy.",
  },
  {
    q: "Is the software customizable?",
    a: "Yes, our solutions can be tailored to fit your company's unique requirements.",
  },
  {
    q: "What industries do you serve?",
    a: "We primarily serve logistics, shipping, and supply chain companies, but our tools can be adapted across industries.",
  },
];

export default function ProductsSection() {
  const [active, setActive] = useState(null);
  const [faqActive, setFaqActive] = useState(null);
  const navigate = useNavigate();

  return (
    <section className="bg-gradient-to-br from-white via-sky-50 to-green-50 py-12 px-4 md:px-8 font-sans">
      {/* ✅ SEO Helmet */}
      <Helmet>
        <title>Products & Services | Quadrangle Solutions</title>
        <meta
          name="description"
          content="Explore AI-powered logistics software, freight forwarding solutions, documentation automation, operations management, and intelligent customer support by Quadrangle Solutions."
        />
        <meta
          name="keywords"
          content="logistics software, freight forwarding, documentation automation, operations management, AI chatbots, Quadrangle Solutions"
        />
        <meta name="author" content="Quadrangle Solutions" />

        {/* Open Graph (Facebook/LinkedIn) */}
        <meta
          property="og:title"
          content="Products & Services | Quadrangle Solutions"
        />
        <meta
          property="og:description"
          content="Discover digital solutions for logistics, freight forwarding, operations, and AI customer support from Quadrangle Solutions."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://quadranglesolutions.com/products"
        />
        <meta
          property="og:image"
          content="https://quadranglesolutions.com/assets/products-og.jpg"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Products & Services | Quadrangle Solutions"
        />
        <meta
          name="twitter:description"
          content="AI-powered logistics, freight forwarding, and operations management solutions by Quadrangle Solutions."
        />
        <meta
          name="twitter:image"
          content="https://quadranglesolutions.com/assets/products-og.jpg"
        />

        {/* Canonical */}
        <link rel="canonical" href="https://quadranglesolutions.com/products" />
      </Helmet>

      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-green-700">
            Products & Services
          </h2>
          <p className="text-slate-600 mt-3 max-w-2xl mx-auto text-sm sm:text-base">
            Comprehensive digital solutions for logistics, shipping, freight
            forwarding, and customer support.
          </p>
        </div>

        {/* Product Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {PRODUCTS.map((product, index) => (
            <motion.div
              key={index}
              className="bg-white p-6 rounded-xl shadow-lg border border-slate-200 cursor-pointer hover:shadow-2xl hover:border-green-400 transition"
              whileHover={{ scale: 1.05 }}
              onClick={() => setActive(product)}
            >
              <h3 className="text-xl font-bold text-green-700 mb-3">
                {product.title}
              </h3>
              <p className="text-slate-600 text-sm">{product.description}</p>
            </motion.div>
          ))}
        </div>

        {/* FAQ Section */}
        <div className="mt-16">
          <h3 className="text-2xl font-bold text-center text-green-700 mb-8">
            Frequently Asked Questions
          </h3>
          <div className="max-w-3xl mx-auto">
            {FAQS.map((faq, index) => (
              <div
                key={index}
                className="border-b border-slate-200 py-4 cursor-pointer"
                onClick={() => setFaqActive(faqActive === index ? null : index)}
              >
                <div className="flex justify-between items-center">
                  <h4 className="text-lg font-semibold text-slate-800">
                    {faq.q}
                  </h4>
                  <span className="text-green-600">
                    {faqActive === index ? "-" : "+"}
                  </span>
                </div>
                {faqActive === index && (
                  <p className="text-slate-600 mt-2 text-sm">{faq.a}</p>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Call to Action */}
        <div className="mt-16 text-center">
          <motion.button
            onClick={() => navigate("/contact")}
            className="bg-green-600 text-white px-6 py-3 rounded-lg shadow-md hover:bg-green-700 transition"
            whileHover={{ scale: 1.05 }}
          >
            Request a Demo
          </motion.button>
        </div>

        {/* Modal for Product Details */}
        {active && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-6 z-50">
            <motion.div
              className="bg-white rounded-xl shadow-lg max-w-lg w-full p-8 relative"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
            >
              <button
                onClick={() => setActive(null)}
                className="absolute top-3 right-3 text-slate-500 hover:text-red-500 text-2xl"
              >
                ×
              </button>
              <h3 className="text-2xl font-bold text-green-700 mb-4">
                {active.title}
              </h3>
              <p className="text-slate-600 mb-4">{active.description}</p>
              <ul className="list-disc list-inside text-slate-700 space-y-2">
                {active.details.map((d, i) => (
                  <li key={i}>{d}</li>
                ))}
              </ul>
            </motion.div>
          </div>
        )}
      </div>
    </section>
  );
}
